import { render, staticRenderFns } from "./pages2A.vue?vue&type=template&id=b3578642&scoped=true&"
import script from "./pages2A.vue?vue&type=script&lang=js&"
export * from "./pages2A.vue?vue&type=script&lang=js&"
import style0 from "./pages2A.vue?vue&type=style&index=0&id=b3578642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3578642",
  null
  
)

export default component.exports